var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5491 15.1673C16.6876 15.0751 16.8469 15.019 17.0126 15.0039C17.1782 14.9889 17.345 15.0154 17.4979 15.081L23.393 17.7224C23.5917 17.8073 23.7575 17.9542 23.8657 18.1413C23.9738 18.3283 24.0185 18.5453 23.993 18.7599C23.7988 20.2112 23.0841 21.5426 21.9818 22.5065C20.8795 23.4704 19.4647 24.0011 18.0004 24C13.4916 24 9.16749 22.2089 5.9793 19.0207C2.79111 15.8325 1 11.5084 1 6.99962C0.998882 5.53534 1.52961 4.12049 2.49349 3.0182C3.45736 1.9159 4.78878 1.20119 6.24012 1.00698C6.45466 0.981496 6.6717 1.02618 6.85873 1.13434C7.04576 1.2425 7.19273 1.40833 7.27764 1.607L9.91895 7.50713C9.98385 7.65867 10.0103 7.8239 9.99588 7.98812C9.98149 8.15235 9.92672 8.31046 9.83645 8.4484L7.16514 11.6247C7.07038 11.7677 7.01435 11.9328 7.00252 12.1039C6.99069 12.2751 7.02346 12.4463 7.09764 12.601C8.13141 14.7173 10.319 16.8786 12.4415 17.9024C12.597 17.9762 12.769 18.0083 12.9407 17.9953C13.1123 17.9824 13.2776 17.9249 13.4203 17.8286L16.5491 15.1673Z",
    stroke: "#56736C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon2);
export default __webpack_public_path__ + "static/media/call-icon-2.9243ca8f64d0a7f93400ca18da1dd5d6.svg";
export { ForwardRef as ReactComponent };